<!-- Terms -->
@if (termable) {
    <div class="col">
        <section class="card">
            <div class="card-body">
                <div class="row">
                    <form [formGroup]="terms" class="col">
                        <ul id="term-items">
                            <li>
                                <label for="lienholderId" id="lienholder-primary">Lienholder</label>
                                <contact-advanced-search type="lienholder" key="primary" 
                                    [contactIdSaved]="(lienholders && (lienholders.length > 0)) ? lienholders[0].lienholderContactId : 0" 
                                    [contactNameSaved]="(lienholders && (lienholders.length > 0) && (lienholders[0].contact)) ? lienholders[0].contact.companyName : null" 
                                    (setContactId)="lienholderChosen($event, true, 0)" [isDisabled]="!isUnLock" [displayLabel]="false">
                                </contact-advanced-search>
                            </li>
                            <li>
                                <label>Amount to Finance</label>
                                <div class="text-right">{{amountToFinance | currency}}</div>
                            </li>
                            @if (taxDeferred) {
                                <li>
                                    <label>Sales Tax (deferred)</label>
                                    <div class="text-right">{{salesTax | currency}}</div>
                                </li>
                            }
                            <li>
                                <label>Subject to Finance</label>
                                <div class="text-right">{{terms.get('financed').value | currency}}</div>
                            </li>
                            <li>
                                <label>Finance Charges (interest)</label>
                                <div class="text-right">{{terms.get('interest').value | currency}}</div>
                            </li>
                            <li>
                                <label>Total of Payments</label>
                                <div class="text-right">{{terms.get('payments').value | currency}}</div>
                            </li>
                            <li class="divider">&nbsp;</li>
                            <li>
                                <label for="paymentCycleId">Payment Cycle (frequency)</label>
                                <select class="form-control form-control-sm" id="paymentCycleId" formControlName="paymentCycleId" (change)="changed($event)">
                                    @for (frequency of frequencies; track frequency.id) {
                                        <option [value]="frequency.id">{{frequency.name}}</option>
                                    }
                                </select>
                            </li>
                            <li>
                                <label for="apr">APR (%)</label>
                                <percent-input [id]="'apr'" [control]="this.terms.get('apr')" (committed)="changed($event)" (blurred)="changed($event)"></percent-input>
                            </li>
                            <li>
                                <span class="small" [class.text-danger]="(maxApr && (apr > maxApr))">{{(maxApr && (maxApr >= 0)) ? 'Max Legal APR: ' + (maxApr | number:'1.2-4') : ''}}</span>
                                @if (dealerAPRLimit > 0) {
                                    <span class="small" [class.text-danger]="(dealerAPRLimit && (apr > dealerAPRLimit))">Max Dealer APR: {{dealerAPRLimit | number:'1.2-4'}}</span>
                                }
                                @if (this.terms.get('contractRate').value > 0) {
                                    <span class="small">Disclosed APR: {{this.terms.get('contractRate').value | number:'1.2-6'}}</span>
                                }
                            </li>
                            <li>
                                <label for="first"><strong>1st Scheduled Payment Due</strong></label>
                                <input type="date" class="form-control form-control-sm" id="first" formControlName="first" (change)="changed($event)" />
                            </li>
                            <li>
                                <label for="payment"><strong>Scheduled Payment</strong></label>
                                <currency-input [id]="'payment'" [control]="this.terms.get('payment')" (committed)="changed($event)" (blurred)="changed($event)"></currency-input>
                            </li>
                            <li>
                                <label><strong>Final Payment</strong></label>
                                <div class="text-right">{{terms.get('final').value | currency}}</div>
                            </li>
                            <li>
                                <label>Final Payment Due (maturity)</label>
                                <div class="text-right">{{terms.get('maturity').value | date}}</div>
                            </li>
                            <li>
                                <label for="term">Number of Payments</label>
                                <count-input [id]="'term'" [control]="this.terms.get('term')" (committed)="changed($event)" (blurred)="changed($event)"></count-input>
                            </li>                            
                        </ul>
                    </form>
                </div>

            </div>
        </section>
    </div>
}